import { useCrmNavigation } from 'hooks/useCrmNavigation'
import { Building2 } from 'lucide-react'
import { CompanyRowData } from 'types/crm/company'

function CompanyRow({ company }: { company: CompanyRowData }) {
  const { toViewCompany } = useCrmNavigation()
  const subtitle = [company.industry, company.cityLocation].filter(Boolean).join(' · ')

  const handleClick = () => {
    if (!company.companyKey) {
      console.warn(`CompanyRow: missing companyKey for company uuid=${company.uuid}`)
      return
    }
    toViewCompany(company.companyKey)
  }

  return (
    <div
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleClick()
        }
      }}
      className="flex cursor-pointer items-center gap-3 px-1 py-2.5 hover:bg-primary-surface hover:rounded-lg"
    >
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary-variant">
        <Building2 size={16} className="text-neutral-faded" />
      </div>
      <div className="min-w-0">
        <div className="truncate text-[14px] font-bold text-neutral-faded capitalize">{company.name}</div>
        {subtitle && (
          <div className="truncate text-[12.5px] text-neutral-faded capitalize">{subtitle}</div>
        )}
      </div>
    </div>
  )
}

export default CompanyRow